<template>
  <div class="card-collection-quantity">
    <div
      v-for="(item, i) in individualCards"
      :key="i"
      class="item"
    >
      <align class="header" justify="space-between">
        <span class="number">Card #{{ i + 1 }}</span>
        <icon-button class="trash" icon="delete_outline" @click="removeCard(i)" />
      </align>

      <div class="input-group">
        <currency-input
          v-model="individualCards[i].investment"
          label="Purchase Price"
          placeholder="1000"
          required
        />

        <date-input
          v-model="individualCards[i].datePurchased"
          label="Purchase Date"
        />
      </div>

      <div>
        <checkbox
          v-model="individualCards[i].sold"
          label="Mark as sold"
        />
      </div>

      <div v-show="individualCards[i].sold" class="input-group">
        <currency-input
          v-model="individualCards[i].priceSold"
          placeholder="2000"
          label="Sale Price"
          :required="individualCards[i].sold"
        />

        <date-input
          v-model="individualCards[i].dateSold"
          label="Sale Date"
        />
      </div>

      <div>
        <checkbox
          v-model="individualCards[i].ownsPercentage"
          label="Setup fractional ownership"
        />
      </div>


      <div v-show="individualCards[i].ownsPercentage">
        <text-input
          v-model="individualCards[i].ownershipPercentage"
          type="number"
          label="What percentage do you own?"
          placeholder="50"
        />
      </div>
    </div>

    <add-link
      v-if="individualCards && individualCards.length < limit"
      class="icon-link"
      @click="addCard"
    >
      Add another card
    </add-link>
  </div>
</template>

<script>
import clone from 'lodash.clonedeep';

import { MANAGE_QUANTITY_LIMIT } from '@cardladder/shared/constants';

export default {
  props: {
    value: Array,
    card: Object,
  },

  data() {
    return {
      limit: MANAGE_QUANTITY_LIMIT,
      individualCards: clone(this.value),
    };
  },

  mounted() {
    this.addEmpty();
  },

  watch: {
    individualCards: {
      handler(value) {
        this.$emit('input', value);
        this.addEmpty();
      },
      deep: true,
    },

    value: {
      handler(value) {
        this.individualCards = value;
      },
      deep: true,
    },
  },

  methods: {
    addEmpty() {
      if (!this.individualCards || this.individualCards.length === 0) {
        this.addCard();
      }
    },

    addCard() {
      if (!this.individualCards) {
        this.individualCards = [];
      }

      const isFirstIndividualCard = this.individualCards.length === 0;

      const initialCard = {
        investment: isFirstIndividualCard ? this.card.investment : null,
        datePurchased: isFirstIndividualCard ? this.card.datePurchased : new Date(),
        sold: isFirstIndividualCard ? this.card.sold : false,
        priceSold: isFirstIndividualCard ? this.card.priceSold : null,
        dateSold: isFirstIndividualCard ? this.card.dateSold : new Date(),
        ownsPercentage: isFirstIndividualCard ? this.card.ownsPercentage : false,
        ownershipPercentage: isFirstIndividualCard ? this.card.ownershipPercentage : null,
      };

      this.individualCards.push(initialCard);
    },

    removeCard(i) {
      this.individualCards.splice(i, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid var(--theme-border);
  margin-bottom: $gp;
  padding: $gp $gp 0;
  border-radius: $gp;
}

.icon-link  {
  margin-bottom: $gp * 2;
}

.header {
  margin-bottom: $gp;
}
</style>
